import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Pet {
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }

    pg_pets_info(payload) {
        payload['in_pet_breed'] = {
            value: this.ctx.getters.funnel.elements['in_pet_breed'].value,
            options: this.ctx.getters.funnel.elements['in_pet_breed'].options
        };
    }

    pg_pets_coverage(payload) {
        const piduid = 'in_pet_selected_plan_id';
        const pnuid = 'in_pet_selected_plan_name';
        const elems = this.ctx.getters.funnel.elements;
        if (!Utils.isEmpty(elems[pnuid].value)) {
            this.setPlanIDFromPlanName(elems[pnuid].value);

            const pID = {
                value: this.ctx.getters.funnel.elements[piduid].value
            };
            payload[piduid] = pID;
        }

        if (elems.in_pet_selected_plan_name.value === 'accident') {
            payload['in_pet_annual_limit'] = { value: 10000 };
            payload['in_pet_deductible'] = { value: 250 };
            payload['in_pet_reimbursement'] = { value: 0.9 };
        }
    }

    pg_pets_summary(payload) {
        payload['in_pet_quote_id'] = { value: this.ctx.getters.funnel.elements['in_pet_quote_id'].value };
    }

    pg_pets_payment_info(payload) {
        payload['in_pet_quote_id'] = { value: this.ctx.getters.funnel.elements['in_pet_quote_id'].value };
    }

    breedToggle(e, input, args) {
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_pet_breed', key: 'typed_option', val: '' });

        let breedOptions;

        if (input.value === 'Cat') {
            breedOptions = this.ctx.getters.funnel.elements.in_pet_breeds_cats.options;
        } else {
            breedOptions = this.ctx.getters.funnel.elements.in_pet_breeds_dogs.options;
        }

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_pet_breed', key: 'options', val: breedOptions });
    }

    setBreedId(e, input, args) {
        const breedName = this.ctx.getters.funnel.elements.in_pet_breed.value;
        const breedId = this.ctx.getters.funnel.elements.in_pet_breed.options.find(option => option.label === breedName)?.value;
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_pet_breed_id', key: 'value', val: breedId });
    }

    updateCoverages(e, input, args) {
        const elements = this.ctx.getters.funnel.elements;

        if (parseInt(elements.in_pet_deductible.value) === 50) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_pet_reimbursement', key: 'value', val: 0.7 });
        }

        this.ctx.dispatch('fetchCoverage', {
            limit: parseInt(elements.in_pet_annual_limit.value),
            deductible: parseInt(elements.in_pet_deductible.value),
            reimbursement: parseFloat(elements.in_pet_reimbursement.value),
            wellness: parseInt(elements.in_pet_wellness_level.value),
            plan: elements.in_pet_selected_plan_name.value
        });
    }

    updateSelectedPlanID(e, input) {
        this.setPlanIDFromPlanName(e.target.value);
    }

    setPlanIDFromPlanName(planName) {
        const planOptions = this.ctx.getters.funnel.elements.in_pet_selected_plan_name.options;
        for (let option of planOptions) {
            if (option.value === planName) {
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_pet_selected_plan_id', key: 'value', val: option.data.plan_id });
                break;
            }
        }
    }

    updatePet(petNo) {
        const srv = this;
        const elems = this.ctx.getters.funnel.elements;
        var petUids = {};
        var payload = {};
        const uids = Object.keys(elems);
        petUids = uids.filter(function (uid) {
            if (elems[uid].value != '' &&
                uid.indexOf(srv.petNoStr(petNo)) != -1 &&
                !Utils.isTruthy(elems[uid].hidden)
            ) {
                return true;
            }
            return false;
        });
        for (const uid of petUids) {
            payload[uid] = { value: elems[uid].value };
        }
        return payload;
    }

    addPet(e, input) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('pet-service: addPet.');
            let resetLoader = false;
            if (this.validatePets()) {
                this.ctx.dispatch('createPetElem', { payload: {} });
            } else {
                resetLoader = true;
            }

            if (resetLoader)
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_pet', key: 'loading', val: false });
        }
    }

    petActionBtns(e, input) {
        const func = (e.type == 'change') ? e.target.value.toLowerCase() : e.target.id;
        const fxn = `${func}Pet`;
        eval(`this.${fxn}(e, input)`);
    }

    editPet(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            const uid = 'in_pet_opType';
            const pOpType = this.ctx.getters.funnel.elements[uid].value;
            if (pOpType == '' || pOpType == 'edit') {
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: 'edit' });
                const petNo = elem.uid.split('_').pop();
                this.createPetAdHocSeq(petNo);
                //this.processPetMaxLimit();
                this.ctx.dispatch('editPetElem', { payload: elem });
            }
        }
    }

    createPetAdHocSeq(ctxPetNo) {
        const piPuid = `pg_pets_info_${ctxPetNo}`;
        const pcPuid = `pg_pets_coverage_${ctxPetNo}`;
        const srcPuid = 'pg_pets_summary';
        const elems = this.ctx.getters.funnel.elements;

        const srcPage = {
            'puid': srcPuid,
            'route': elems[srcPuid].page_route
        };
        var pagesObj = {};
        pagesObj[piPuid] = elems[piPuid].page_route;
        pagesObj[pcPuid] = elems[pcPuid].page_route;

        this.fs.createAdHocSeq(srcPage, pagesObj);
    }

    validatePets() {
        const pets = this.getPetElems();
        var isValid = false;
        var inValidPets = [];
        var pet = {};
        for (const uid of pets) {
            Object.assign(pet, this.ctx.getters.funnel.elements[uid]);
            pet.id = `${pet.id}-id`;
            if (!this.fs.isValid(pet)) {
                inValidPets.push(uid);
            }
        }
        isValid = inValidPets.length == 0;
        return isValid;
    }

    getPetElems(type = 'summary') {
        const inSeqLen = this.fs.getPageInputSeqBySuid(`pg_pets_${type}`, `sc_pets_${type}`);
        return inSeqLen.filter(this.fs.checkStrMatch, { ctrl: 'in_pet_' });
    }

    getPetsCount() {
        let petsCount = 0;
        const petMatches = this.getPetElems();
        if (petMatches) {
            petsCount = petMatches.length;
        }
        console.log('No. of Pets:', petsCount);
        return petsCount;
    }

    deletePet(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('Deleting pet.');

            this.ctx.dispatch('deletePetElem', { payload: elem });
        }
    }

    ccBankToggle(e, input, args) {
        if (input.value === 'bank') {
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }

        if (input.value === 'cc' && this.fs.ctx.getters.funnel.elements.in_cc_exp_valid.value === false) {
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        }
    }

    validateCCExpiration(e, input, args) {
        let expMonth;
        let expYear;

        if (input.id === 'in_cc_exp_year') {
            expMonth = this.fs.ctx.getters.funnel.elements.in_cc_exp_month.value;
            expYear = input.value;
        } else {
            expMonth = input.value;
            expYear = this.fs.ctx.getters.funnel.elements.in_cc_exp_year.value;
        }

        const currentDate = new Date();
        const monthMap = {
            'January': 0,
            'February': 1,
            'March': 2,
            'April': 3,
            'May': 4,
            'June': 5,
            'July': 6,
            'August': 7,
            'September': 8,
            'October': 9,
            'November': 10,
            'December': 11
        };

        expMonth = monthMap[expMonth];
        const expDate = new Date(expYear, expMonth + 1, 0);

        if (currentDate > expDate) {
            this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_cc_exp_valid', key: 'value', val: false });
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        } else {
            this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_cc_exp_valid', key: 'value', val: true });
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }
    }

    toggleAccidentProtection(){
        let oldVal = this.fs.ctx.getters.funnel.elements.in_is_accident_protection_only.value;

        if (typeof oldVal === 'string') {
            oldVal = oldVal.toLowerCase() === 'true' ? true : false;
        }
        if (!oldVal) {
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_accident_protection_toggle', key: 'label', val: "Upgrade to Accident and Illness coverage" });
        }else{
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_accident_protection_toggle', key: 'label', val: "I'm only interested in accident protection" });
        }

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_is_accident_protection_only', key: 'value', val: !oldVal });
    }

    minimumAge(e, input, args) {
        const errorElement = document.querySelector('#in_pet_age_minAgeError');
        const select = document.querySelector(`#${input.id}`);

        if (parseInt(input.value) === -1 && !errorElement) {
            const error = document.createElement('small');

            select.blur();
            select.classList.remove('type_1_select');
            select.classList.add('error');

            error.textContent = this.ctx.getters.funnel.elements[input.id].error_message;
            error.ariaLabel = this.ctx.getters.funnel.elements[input.id].error_message;
            error.classList.add('error');
            error.id = 'in_pet_age_minAgeError';

            select.parentNode.insertBefore(error, select.nextSibling);

            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        } else if (parseInt(input.value) !== -1 && errorElement) {
            errorElement.remove();
            select.classList.add('type_1_select');
            select.classList.remove('error');

            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }
    }
}